import React, { useEffect, useState } from 'react';
import './StopWatch.css';
import { useIsMount } from '../../../../../hooks/useIsMountHook';

interface Props {
  /** Initial Stopwatch delay in milliseconds*/
  initialDelay: number;
  isRunning: boolean;
}

const countInitialTime = (millis: number) => {
  if (!millis) {
    return 0;
  }

  //Otherwise divide the millis by 10 to match the format of this stopwatch
  return millis / 10;
};

const Stopwatch = (props: Props) => {
  // state to store time
  const [time, setTime] = useState(countInitialTime(props.initialDelay));

  // state to check stopwatch running or not
  const [isRunning, setIsRunning] = useState(props.isRunning);

  const isMount = useIsMount();

  useEffect(() => {
    let intervalId;
    if (isRunning) {
      // setting time from 0 to 1 every 1000 milisecond using javascript setInterval method
      intervalId = setInterval(() => setTime(time + 100), 1000);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, time]);

  useEffect(() => {
    if (!isMount) {
      setIsRunning(props.isRunning);
    }
  }, [props.isRunning]);

  // Uncomment following lines for having more time values in the StopWatch (showing millis / hours)
  // Hours calculation
  // const hours = Math.floor(time / 360000);

  // Minutes calculation
  const minutes = Math.floor((time % 360000) / 6000);

  // Seconds calculation
  const seconds = Math.floor((time % 6000) / 100);

  // Milliseconds calculation
  //const milliseconds = time % 100;

  return (
    <div className="stopwatch-container">
      <p className="stopwatch-time">
        {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        {/*:{milliseconds.toString().padStart(2, '0')}*/}
      </p>
    </div>
  );
};

export default Stopwatch;
